import fav from "../../mobile/tabs/fav.jsx";
import history from "./history.jsx";
import addresses from "./addresses.jsx";
import wallet from "../../mobile/tabs/wallet.jsx";
import account from "../../mobile/tabs/account.jsx";

const tabs = { addresses, fav, history, wallet, account };

export default tabs;
